<template>
    <div class="content">
        <div>
            <el-form label-width="90px">
                <el-row>
                    <el-col :span="5" >
                        <el-form-item label="数据来源">
                            <el-select
                                @change="changeDateFrom"
                                v-model="dateFromStatus"
                                placeholder="请选择回访状态"
                                style="width: 100%"
                            >
                                <el-option
                                    v-for="item in dateFrom"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <div class="search_wrapper"  v-if="serveInfoStatus">
            <div class="search_head">
                <span>查询条件</span>
                <i class="searchDomw" @click="isSearchContent = !isSearchContent" :class="isSearchContent == true ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
                <!-- <el-button
                    style="float: right; padding: 3px 0; color: #000"
                    type="text"
                    @click="clearData"
                >
                    <i class="el-icon-refresh"></i>
                    刷新页面
                </el-button> -->
            </div>
            <div class="search_content"  v-show="isSearchContent">
                <div class="search_inline">
                    <el-form label-width="90px">
                        <el-row>
                            <el-col :span="5">
                                <el-form-item label="姓名">
                                    <el-input
                                        v-model="customerName"
                                        placeholder="姓名"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="5" :offset="1">
                                <el-form-item label="回访状态">
                                    <el-select
                                        v-model="backStatus"
                                        placeholder="请选择回访状态"
                                        style="width: 100%"
                                    >
                                        <el-option
                                            v-for="item in takeList"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value"
                                        >
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>

                            <el-col :span="5" :offset="2">
                                <el-button
                                    type="primary"
                                    icon="el-icon-search"
                                    @click="searchData"
                                    class="searchBtns"
                                    >搜索</el-button
                                >
                                <el-button
                                    type="info"
                                    icon="el-icon-delete"
                                    @click="clearData"
                                    >清除条件</el-button
                                >
                            </el-col>
                        </el-row>
                    </el-form>
                </div>
                <!-- <div class="arrowDown">
                    <i
                        :class="
                            isSearchContent === true
                                ? 'el-icon-arrow-up'
                                : 'el-icon-arrow-down'
                        "
                        style="color: #000"
                        @click="isSearchContent = !isSearchContent"
                    ></i>
                </div> -->
            </div>
        </div>
        <div class="table_title" v-if="serveInfoStatus">
            <div class="btn_group">
                <el-button-group>
                    <el-button
                        type="success"
                        icon="iconfont icon-xinzeng"
                        class="openBtns"
                        @click="addForm"
                        >评价内容设置</el-button
                    >
                </el-button-group>
            </div>
            <!-- 筛选按钮 -->
            <div class="screen_container">
                <el-button-group>
                    <el-button
                        type="primary"
                        icon="el-icon-refresh"
                        class="dropRests"
                        @click="clearData"
                    ></el-button>
                    <!-- <el-button type="primary" style="padding: 10px 20px"> -->
                        <el-dropdown trigger="click" :hide-on-click="false" class="dropdown1">
                            <span class="el-dropdown-link">
                                <i
                                    class="el-icon-s-grid el-icon--right"
                                    style="color: #fff"
                                ></i>
                                <i
                                    class="el-icon-arrow-down el-icon--right"
                                ></i>
                            </span>
                            <el-dropdown-menu
                                slot="dropdown"
                                class="table_checkbox"
                            >
                                <el-dropdown-item>
                                    <el-checkbox-group
                                        v-model="tableChekbox"
                                        @change="tableChekboxChange"
                                    >
                                        <el-checkbox label="序号"></el-checkbox
                                        ><br />
                                        <el-checkbox label="姓名"></el-checkbox
                                        ><br />
                                        <el-checkbox label="性别"></el-checkbox
                                        ><br />
                                        <el-checkbox label="年龄"></el-checkbox
                                        ><br />
                                        <el-checkbox
                                            label="联系电话"
                                        ></el-checkbox
                                        ><br />
                                        <el-checkbox
                                            label="用户类型"
                                        ></el-checkbox
                                        ><br />
                                        <el-checkbox label="状态"></el-checkbox
                                        ><br />
                                        <el-checkbox label="操作"></el-checkbox
                                        ><br />
                                    </el-checkbox-group>
                                </el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    <!-- </el-button> -->
                </el-button-group>
            </div>
        </div>
        <!--服务工单信息 tableb表格 -->
        <div v-if="serveInfoStatus" class="table_container">
            <el-table
                :data="tableData"
                tooltip-effect="dark"
                style="width: 100%"
                height="550px"
                :header-cell-style="{ background: '#e6e6e6', color: '#000' }"
                border
            >
                <el-table-column
                    type="index"
                    width="70"
                    label="序号"
                    align="center"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '序号'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                    <template scope="scope">
                        <span
                            >{{
                                scope.$index +
                                (pageOne.pageNo - 1) * pageOne.pageSize +
                                1
                            }}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column
                    label="姓名"
                    align="center"
                    prop="name"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '姓名'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                />
                <el-table-column
                    label="性别"
                    align="center"
                    prop="sex"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '性别'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                    <template scope="scope">
                        <span v-if="scope.row.sex == 0">男</span>
                        <span v-if="scope.row.sex == 1">女</span>
                    </template>
                </el-table-column>
                <el-table-column
                    label="年龄"
                    align="center"
                    prop="age"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '年龄'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                />
                <el-table-column
                    label="联系电话"
                    align="center"
                    prop="phone"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '联系电话'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                />
                <el-table-column
                     prop="type"
                    label="用户类型"
                    align="center"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '用户类型'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                    <template slot-scope='scope'>
                                        <span v-if='scope.row.type == 1'
                                        >普通客户</span
                                        >
                                        <span v-if='scope.row.type == 2'
                                        >按康宝客户</span
                                        >
                                        <span v-if='scope.row.type == 3'
                                        >残联</span
                                        >
                                         <span v-if='scope.row.type == 4'
                                        >老干部</span
                                        >
                                          <span v-if='scope.row.type == 5'
                                        >计生委</span
                                        >
                                          <span v-if='scope.row.type == 6'
                                        >民政</span
                                        >
                                          <span v-if='scope.row.type == 7'
                                        >商业客户</span
                                        >
                                          <span v-if='scope.row.type == 8'
                                        >D类服务对象</span
                                        >
                                         <span v-if='scope.row.type == 10'
                                        >文明办</span
                                        >
                                         <span v-if='scope.row.type == 11'
                                        >          label: '军人事务局'
</span
                                        >
                                  </template>
                </el-table-column>
                <el-table-column
                    label="状态"
                    align="center"
                    prop="states"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '状态'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                    <template scope="scope">
                        <span v-if="scope.row.states == 0">未回访</span>
                        <span v-if="scope.row.states == 1">已回访</span>
                    </template>
                </el-table-column>

                <el-table-column
                    label="操作"
                    align="center"
                    width="200px"
                    fixed="right"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '操作'
                        ) != -1
                    "
                >
                    <template slot-scope="scope">
                        <span
                            @click="handleTableForm('查看', scope.row, 0)"
                            style="margin-right: 12px; cursor: pointer"
                            >查看</span
                        >
                        <span
                            @click="handleTableForm('回访信息', scope.row, 2)"
                            style="margin-right: 12px; cursor: pointer"
                            >回访信息</span
                        >
                        <span
                            @click="deleteItem(scope.row)"
                            style="margin-right: 12px; cursor: pointer"
                            v-if="false"
                            >删除</span
                        >
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination_container">
                <el-pagination
                    :page-size="pageOne.pageSize"
                    :current-page.sync="pageOne.pageNo"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="pageOne.total"
                    @size-change="handletableDataSize"
                    @current-change="handleTableDataChange"
                ></el-pagination>
            </div>
        </div>
        <add-list
            v-if="personVisible"
            :openData="personInfo"
            @canclePerson="cancleSet"
        ></add-list>
        <visit-main
            v-if="dialogVisible"
            :openData="dialogInfo"
            @canclePerson="cancleSet"
        ></visit-main>

        <!-- 老人订餐信息table表格 -->
         <ordering-info v-if="OrderingInfoStatus"></ordering-info>
    </div>
</template>
<script>
import addList from "./components/addList"
import orderingInfo from "./components/orderingInfo"
import visitMain from "./components/visitMain"
import { getData } from "./api/index"

export default {
    props: ["personData"],
    components: { addList, visitMain,orderingInfo },
    data() {
        return {
            customerName:"",
            serveInfoStatus:true,
            OrderingInfoStatus:false,
            dateFromStatus:0,
            dateFrom:[
                { value: 0, label: "服务工单" },
                { value: 1, label: "订餐" },
            ],
            takeList: [
                { value: "0", label: "未回访" },
                { value: "1", label: "已回访" },
            ],
            dialogVisible: false,
            dialogInfo: {},
            personVisible: false,
            personInfo: {},
            name: "",
            backStatus: "",
            sex: "",
            isSearchContent: false,
            pageOne: { pageSize: 10, pageNo: 1, total: 0 },
            tableData: [],
            radioId: "",
            tempTableChekbox: [
                "序号",
                "姓名",
                "性别",
                "年龄",
                "联系电话",
                "用户类型",
                "状态",
                "操作",
            ],
            tableChekbox: [
                "序号",
                "姓名",
                "性别",
                "年龄",
                "联系电话",
                "用户类型",
                "状态",
                "操作",
            ]
    }
        
    },
    created() {
        this.getList();
    },
    watch: {
        personData(old, news) {
            // console.log(old, news, this.personData, "组织id");
            this.getList()
        },
    },
    methods: {
        // 切换数据来源
        changeDateFrom(){
            let vm = this;
            if(vm.dateFromStatus == 0){
                vm.serveInfoStatus = true;
                vm.OrderingInfoStatus = false;
            }else{
                vm.serveInfoStatus = false;
                vm.OrderingInfoStatus = true;
            }
        },
        // 新增
        addForm() {
            this.personVisible = true
            this.dialogVisible = false
            this.personInfo = {
                id: "",
                state: true,
                socialOrgId: this.personData,
            }
        },
        cancleSet() {
            this.personVisible = false
            this.dialogVisible = false
            this.getList()
        },
        // 搜索
        searchData() {
            this.getList()
        },
        // 关闭人员信息弹窗
        cancleOpen() {
            this.dialogInfo = {}
            this.dialogVisible = false
            // this.tableData = [];
            this.getList()
        },
        //删除表格信息
        deleteItem(date) {
            let params = {
                communityWorkerId: date.id,
                socialOrgId: this.personData,
            }
            this.$confirm("确认永久删除吗?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                this.$http
                    .request({
                        url:
                            "/ypt/admin/communityWorker/info/deleteBySocialOrg",
                        method: "POST",
                        data: params,
                    })
                    .then((res) => {
                        if (res.code === 200) {
                            this.$message.success("删除成功")
                            // this.tableData = [];
                            this.getList()
                        }
                    })
            })
        },
        // 当前页
        handleTableDataChange(val) {
            this.pageOne.pageNo = val
            this.getList()
        },
        // 分页大小
        handletableDataSize(val) {
            this.pageOne.pageSize = val
            this.getList()
        },
        // 选择列的展示方式
        tableChekboxChange(val) {
            this.tempTableChekbox = val.map((item) => item)
        },
        //重置
        clearData() {
            this.customerName = ""
            this.backStatus = ""
            this.pageOne.pageSize = 10
            this.pageOne.pageNo = 1
            this.getList()
        },
        // 获取数据
        getList() {
            let { customerName, backStatus } = this
            let params = {
                pageNo: this.pageOne.pageNo,
                pageSize: this.pageOne.pageSize,
                socialOrgId: this.personData,
                customerName,
                backStatus,
            }

            getData(params).then(({ content }) => {
                if (content) {
                    this.tableData = content.list
                    this.pageOne.total = content.count
                }
            })
        },
        // 操作方法
        handleTableForm(title, row, nums) {
            this.dialogVisible = true
            this.personVisible = false
            this.dialogInfo = {
                title: title,
                id: row.id,
                state: true,
                nums: nums,
                commId: this.personData,
                data: row,
            };
            console.log(this.dialogInfo);
        },
    },
}
</script>
<style lang="less" scoped>
/deep/.btn_group {
    margin-top: 0px !important;
}
/deep/.table_title {
    margin-top: 10px !important;
}

/deep/ .search_wrapper {
  display: flex;
  flex-direction: column;
  position: relative;
  background: #F1F2F6;
  box-shadow:  0 0 6px rgba(100, 100, 100, 0.16);
  overflow: hidden;
  border-radius: 4px;
  .search_head {
    background: #fff;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
    color: rgb(0, 0, 0);
    border-color: rgb(217, 217, 217);
    padding: 6px 15px;
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
  }
  .search_content {
    padding: 15px 20px 0px 5px;
    border: 1px solid rgb(217, 217, 217);
    // display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }
  .search_inline {
    width: 100%;
  }
  .arrowDown {
    width: 28px;
    height: 28px;
    background: #edf2f0;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    left: 50%;
    bottom: -14px;
    transform: translate(-50%, 0px);
    border-radius: 50%;
    z-index: 2;
    cursor: pointer;
  }
}
.searchDomw{cursor: pointer;}
</style>